import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import PlaygroundListPage from 'features/playground/pages/PlaygroundListPage';
import PlaygroundEditorPage from 'features/playground/pages/PlaygroundEditorPage';

/**
 * PlaygroundPage — sub-router for `/:team/playground/*`.
 *   /:team/playground            → list of sandboxes
 *   /:team/playground/new        → editor on an unsaved draft (created on first save)
 *   /:team/playground/:id        → editor for one sandbox
 */
export default function PlaygroundPage() {
  const { team } = useParams();
  const { pathname } = useLocation();
  const base = `/${encodeURIComponent(team)}/playground`;
  const after = pathname.startsWith(base)
    ? pathname.slice(base.length).replace(/^\/+/, '').replace(/\/+$/, '')
    : '';
  const parts = after ? after.split('/') : [];

  if (parts.length === 0) return <PlaygroundListPage />;
  return <PlaygroundEditorPage playgroundId={parts[0]} />;
}
